import { IMatchRunPosition } from "./position";
import { IDonor } from "../donor";

export interface IMatchRunSwap {
    chainStart: number,
    positions: IMatchRunPosition[],
    depth: number,
    donor: IDonor
}